import { useEffect, useState } from "react";
import { useAPI } from "../Context/MyContext";

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

const   ProfileOverview = () => {
  const { getAllowedUserFeatures } = useAPI();
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getAllowedUserFeatures();
        if (data) {
          setFormData({
            name: data.name || "",
            email: data.email || "",
            phone: data.phone_number || "",
          });
        }
      } catch (error) {
        console.error("Failed to load profile:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const initials = formData.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 1);

  const fields = [
    { label: "Full Name", value: formData.name },
    { label: "Email Address", value: formData.email },
    { label: "WhatsApp Number", value: formData.phone },
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold mb-8 text-gray-800">Your Profile</h1>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">

        {/* Centered avatar section */}
        <div className="flex flex-col items-center pt-10 pb-8 px-8 border-b border-gray-100">
          {loading ? (
            <>
              <Skeleton className="w-20 h-20 rounded-full mb-4" />
              <Skeleton className="w-40 h-5 rounded-lg mb-2" />
            </>
          ) : (
            <>
              <div className="w-20 h-20 rounded-full bg-emerald-600 flex items-center justify-center text-white text-3xl font-semibold select-none mb-4 shadow-sm">
                {initials || "?"}
              </div>
              <p className="text-xl font-bold text-gray-900">{formData.name || "—"}</p>
              {/* <p className="text-sm text-gray-400 mt-1">{formData.email || "—"}</p> */}
            </>
          )}
        </div>

        {/* Fields — 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-100">
          {fields.map(({ label, value }) => (
            <div key={label} className="flex flex-col items-center justify-center py-7 px-6 text-center">
              <p className="text-[11px] font-semibold tracking-[0.18em] text-emerald-600 uppercase mb-3">
                {label}
              </p>
              {loading ? (
                <Skeleton className="w-28 h-4 rounded-lg" />
              ) : (
                <p className="text-sm font-semibold text-gray-800 break-all">{value || "—"}</p>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ProfileOverview;